import BannerFormacoes from '../../componentes/BannerFormacoes';
import Grid from '../../componentes/Grid';
import InfoFormacoes from '../../componentes/InfoFormacoes';
import styles from './Formacoes.module.css';
import ListaCursos from 'Common/json/cursos.json';
import listaFormacao from 'Common/json/listaFormacao.json'
import { useFormacao } from '../../Common/Context/Formacao';
import PaginaErro from 'Paginas/PaginaErro';
import { useLocation } from 'react-router-dom'
import { motion } from 'framer-motion'

export default function Formacoes() {
    const { escolha, mudaFormacaoEscolhida } = useFormacao()
    const formacaoAtual = listaFormacao.find(formacao => formacao.formacao === escolha)
    const cursos = ListaCursos.filter(curso => curso.formacao === escolha)

    let history = useLocation()
    let local = history.pathname.slice(10,).replaceAll("%20", " ")

    if (!escolha) {

        if (listaFormacao.some(item => item.link === local)) {
            return (
                mudaFormacaoEscolhida(
                    listaFormacao.find(item => item.link === local)
                ))
        } else return (
            <PaginaErro />
        )
    }
    console.log(formacaoAtual)

    return (
        <motion.div
            initial={{ opacity: 0}}
            animate={{ opacity: 1}}
            exit={{opacity:0}}
        >
            <BannerFormacoes titulo={formacaoAtual.formacao} texto={formacaoAtual.texto} logo={formacaoAtual.logo} />
            <InfoFormacoes escola={formacaoAtual.escola} tempo={formacaoAtual.tempo} cursos={formacaoAtual.cursos} artigos={formacaoAtual.artigos} />
            <Grid lista={cursos} />
        </motion.div>
    )
}
